"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let CategoryCard = class CategoryCard extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.controllerColor = new ColorLibController_1.default();
    }
    get hasMultipleMetrics() {
        return this.categorie.metrics.length > 1;
    }
    indexNotLastOne(index) {
        return index !== this.categorie.metrics.length - 1;
    }
    generateColoRank(rank) {
        return this.controllerColor.getRankColor(rank.toString());
    }
    generateColoRankHLT(rank) {
        return this.controllerColor.getDiseasesColor(rank.toString());
    }
    calculateMetricLevel(rank) {
        if (rank === 5) {
            return 'VERY HIGH';
        }
        else if (rank === 4) {
            return 'HIGH';
        }
        else if (rank === 3) {
            return 'MEDIUM';
        }
        else if (rank === 2) {
            return 'LOW';
        }
        else if (rank === 1) {
            return 'VERY LOW';
        }
        else {
            return 'NOT DETECTED';
        }
    }
    calculateMetricLevelInitial(rank) {
        if (rank === 5) {
            return 'vh';
        }
        else if (rank === 4) {
            return 'h';
        }
        else if (rank === 3) {
            return 'm';
        }
        else if (rank === 2) {
            return 'l';
        }
        else if (rank === 1) {
            return 'vl';
        }
        else {
            return '-';
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        default: {
            name: '',
            symbol: '',
            metrics: [],
        },
    })
], CategoryCard.prototype, "categorie", void 0);
CategoryCard = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Tag: bmk_ui_framework_1.Tag, Separator: bmk_ui_framework_1.Separator },
    })
], CategoryCard);
exports.default = CategoryCard;
